import { render, staticRenderFns } from "./ShowScratchCard.vue?vue&type=template&id=6560db0f&scoped=true&"
import script from "./ShowScratchCard.vue?vue&type=script&lang=js&"
export * from "./ShowScratchCard.vue?vue&type=script&lang=js&"
import style0 from "./ShowScratchCard.vue?vue&type=style&index=0&id=6560db0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560db0f",
  null
  
)

export default component.exports